import axios from 'axios'
import getEnvironment from '../getEnvironment'
import { debug } from '../Logger'

interface Cookie {
  session: string
  firstName: string
  lastName: string
  timeZone: string | null
}

function prepareString (string) {

  return string.trim().replace(/\+/g, ' ')

}

/** Fetches cookie and formats it if it's found */
const getCookieData = (): Cookie | null => {

  let cookieMatch

  if (typeof document !== 'undefined') {

    const parts = document.cookie.split(`; BTSESSION=`);

    if (parts.length === 2) {

      cookieMatch = parts.pop().split(';').shift();

    }

    if (!cookieMatch) return null

  } else {

    return null

  }

  const decodedData = decodeURIComponent(cookieMatch)
  const [
    session = '',
    firstName = '',
    lastName = '',
    ,
    timeZone = null
  ] = decodedData.split(':')

  return {
    session,
    firstName: prepareString(firstName),
    lastName: prepareString(lastName),
    timeZone
  }

}

export default {
  getTimezone: (): Cookie['timeZone'] => {

    const { timeZone } = getCookieData() || { timeZone: null }
    return timeZone

  },
  getFullName: (): string => {

    const { firstName, lastName } = getCookieData() || { firstName: '', lastName: '' }
    return `${firstName} ${lastName}`.trim()

  },
  getSession: (): string => {

    const { session } = getCookieData() || { session: '' }
    return session

  },
  isValid: async (): Promise<boolean> => {

    let response

    try {

      response = await axios.get(`${getEnvironment().publicServices}/service/user/session/user`)

    }
    catch (e) {

      debug(e?.message ?? 'Failed to check if user is valid')

    }

    return response.status === 200

  }
}
